import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer} from 'react-toastify';
import { fetchReadOnlyData } from "../../redux/readOnly";
import Navbar from "./components/Navbar";
import Config from "./components/shared/components/Config"
import LoadingBackdrop from "./components/shared/components/LoadingBackdrop";
import ReportModal from "./components/shared/components/ReportModal";

//import Echo from 'laravel-echo';
//import Pusher from 'pusher-js';

const MainLayout = () => {
    const dispatch = useDispatch();
    const loading = useSelector(state => state.loading)
    const [openReport, setOpenReport] = useState(false);

    /*window.Pusher = Pusher;
    window.Echo = new Echo({
        broadcaster: 'reverb',
        key: process.env.REACT_APP_REVERB_APP_KEY,
        wsHost: process.env.REACT_APP_REVERB_HOST,
        wsPort: process.env.REACT_APP_REVERB_PORT ?? 80,
        wssPort: process.env.REACT_APP_REVERB_PORT ?? 443,
        forceTLS: (process.env.REACT_APP_REVERB_SCHEME ?? 'https') === 'https',
        enabledTransports: ['ws', 'wss'],
        apiOriginAllow: {
        allowCors: true,
        allowOrigin: "*",
        allowMethods: "GET,POST",
        allowHeaders: "Origin, Content-Type, X-Auth-Token, X-Requested-With, Accept, Authorization, X-CSRF-TOKEN, X-Socket-Id"
        },
        authorizer: (channel, options) => {
        return {
            authorize: (socketId, callback) => {
                fetch(process.env.REACT_APP_API_BASE + 'broadcasting/auth', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + user.token
                    },
                    body: JSON.stringify({
                        socket_id: socketId,
                        channel_name: channel.name
                    })
                })
                .then(response => response.json())
                .then(data => {
                    callback(false, data);
                })
                .catch((error) => {
                    callback(true, error);
                });
            }
        };
        }
    });*/

    useEffect(() => {
        // MAKE INITIAL LOAD OF READ ONLY DATA ON REDUX STORE
        dispatch(fetchReadOnlyData());
    }, []);

    const handleOpenReportProblem = () => { setOpenReport(true); }
    const handleCloseReportProblem = () => { setOpenReport(false); }

    return (
        <div className="dashboard-container">
            <Navbar onOpenReportProblem={handleOpenReportProblem} />
            <Config />
            
            <Outlet />

            { loading && <LoadingBackdrop /> }

            { (openReport) &&
                <ReportModal 
                    state={openReport}
                    onClose={handleCloseReportProblem}
                />
            }

            <ToastContainer
                containerId="dashboard"
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
            />
        </div> 
    );
}

export default MainLayout